import { styled } from '@mui/system';
import TableCell from '@mui/material/TableCell';

const MyHeaderTableCell = styled(TableCell)({
  textAlign: "center",
  color: "white",
  backgroundColor: "#233044",
});

export default MyHeaderTableCell;